var els = $('[data-popup]');
if (els.length > 0) {
  require.ensure('../modules/popup', function(require) {
    var Popup = require('../modules/popup');
    els.each(function() {
      return new Popup(this);
    });
  });
}



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/popup.initializer.js